import * as React from 'react';
import { Translate } from 'react-localize-redux';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

import SubscriptionsList from './subscriptions-list';

import { ListSubscriptions } from '../../../../store/subscription-manager/action-creators';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ListSubscriptionsResponse } from '@common/types/subscription-manager/list-subscriptions-response';
import AppState from '../../../../store/state';

interface SubscriptionPageProps {
  className?: string;
  summary?: ListSubscriptionsResponse;
  isMobile: boolean;
  listSubscriptions: () => ListSubscriptions;
}

const mapStateToProps = (state: AppState) => ({
  summary: state.subscriptionManager.summary,
  isMobile: state.ui.mobile,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  listSubscriptions: () => dispatch(new ListSubscriptions()),
});

export const SubscriptionPage: React.FC<SubscriptionPageProps> = ({
  className,
  summary,
  listSubscriptions,
  isMobile,
}) => {
  React.useEffect(() => {
    setTimeout(() => {
      listSubscriptions();
    }, 50);
  }, [listSubscriptions]);

  return (
    <MotionOpacity className={className}>
      {!isMobile ? (
        <Typography type="subheader" weight="400" className="mb-40">
          <Translate id="USER_PROFILE.SUBSCRIPTION" />
        </Typography>
      ) : null}
      <SubscriptionsList
        category="artists"
        subscriptions={summary?.artists}
        className="mb-10"
      />
      <SubscriptionsList
        category="recordLabels"
        subscriptions={summary?.recordLabels}
      />
    </MotionOpacity>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscriptionPage);
